module.exports = __webpack_public_path__ + "media/images/rtaImage-f6bdbf97954b2fea49ffba76ecd23ae5.jpeg";